module.exports = __webpack_public_path__ + "static/media/ico_refer.76825691.png";